/*
	支払方法管理画面
	定期購読支払情報　表示画面
*/

import React, { memo, useEffect } from 'react';
import classes from './subscription-info.module.scss';
import { Hr } from 'components/atoms/Hr';
import { PeriodicPaymentDetailToken, callGetPeriodicPaymentDetailApi } from 'requests/RequestPeriodicPayment';
import { SubscriptionDetail } from 'components/molecules/subscription-detail/SubscriptionDetail';
import { PaymentButtonBox } from 'components/molecules/payment-button-box/PaymentButtonBox';
import { HttpStatus } from 'consts/HttpStatus';
import { RoutePath } from 'consts/RoutePath';
import { useHistory } from 'react-router-dom';
import { PaymentToken } from 'requests/RequestPayment';

type Props = {
	paymentTokens: PaymentToken[];
	periodicPaymentId: string;
	periodicPaymentDetail: PeriodicPaymentDetailToken;
	setPeriodicPaymentDetail: React.Dispatch<React.SetStateAction<PeriodicPaymentDetailToken>>;
	paymentUpdateFlg: boolean;
	setPaymentUpdateFlg: React.Dispatch<React.SetStateAction<boolean>>;
	comparisonFlg: boolean;
	setComparisonFlg: React.Dispatch<React.SetStateAction<boolean>>;
	setCardIndex: (cardList: PaymentToken[], paymentDetail: PeriodicPaymentDetailToken) => void;
	setLoadingState: React.Dispatch<React.SetStateAction<boolean>>;
	activeEvent: () => void;
	passiveEvent: () => void;
};
export const SubscriptionInfo = memo((props: Props) => {
	const {
		paymentTokens,
		periodicPaymentId,
		periodicPaymentDetail,
		setPeriodicPaymentDetail,
		setLoadingState,
		paymentUpdateFlg,
		setPaymentUpdateFlg,
		comparisonFlg,
		setComparisonFlg,
		setCardIndex,
		activeEvent,
		passiveEvent,
	} = props;

	const history = useHistory();

	// 定期購読詳細情報取得API
	useEffect(() => {
		if (paymentUpdateFlg || comparisonFlg) {
			const execute = async () => {
				setLoadingState(true);
				const result = await callGetPeriodicPaymentDetailApi(periodicPaymentId);
				if (result.status !== HttpStatus.OK) {
					setLoadingState(false);
					history.push(RoutePath.ERROR);
					return;
				}
				const newPaymentToken = {
					...result.data,
					first_capture_date: new Date(result.data.first_capture_date),
					last_capture_date: new Date(result.data.last_capture_date),
					payment_specify_list: { ...result.data.payment_specify_list },
					site_settlement_setting_display_flg: {
						...result.data.site_settlement_setting_display_flg,
					},
				};
				// 選択した定期購読支払情報がカード支払いの場合、カード選択値をセットする
				setCardIndex(paymentTokens, newPaymentToken);
				setLoadingState(false);
				setPaymentUpdateFlg(false);
				setComparisonFlg(false);
				setPeriodicPaymentDetail(newPaymentToken);
			};

			execute();
		} else {
			setCardIndex(paymentTokens, periodicPaymentDetail);
		}
	}, []);

	return (
		<>
			{periodicPaymentDetail !== undefined && !(paymentUpdateFlg || comparisonFlg) ? (
				<>
					<h1 className="page-head">定期購読詳細</h1>
					<div className="section-in" style={{ marginTop: 50 }}>
						<SubscriptionDetail periodicPaymentToken={periodicPaymentDetail} />
						<Hr />
						<div className={classes.subscriptionRow}>
							<PaymentButtonBox
								activeMessage={'支払方法変更'}
								passiveMessage={'一覧へ戻る'}
								activeEvent={activeEvent}
								passiveEvent={passiveEvent}
							/>
						</div>
					</div>
				</>
			) : null}
		</>
	);
});
